const React = require('react')
const PropTypes = require('prop-types')
const { getTargetSize } = require('./get_target_size')
const { getCloudflareUrl } = require('@aboutdotme/image-helpers')
const Raven = require('lib/raven')
const log = require('log').create('portfolio', 'image') // eslint-disable-line
const config = require('lib/config')

class PortfolioImage extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            image: props.image,
            max: {
                width: 1200,
                height: 600,
            },
        }
    }

    componentDidMount() {
        this.verifyDimensions()
    }

    getUrl() {
        const { image, max } = this.state
        return getCloudflareUrl(image, {
            width: max.width,
            height: max.height,
            quality: 80,
            crop: false,
            devicePixelRatio: 2,
            image_domain: config.get('pumpkinhead.globals.aws_images'),
        })
    }

    verifyDimensions() {
        const detectImageSize = require('lib/detect_image_size')
        const url = this.getUrl()
        const { image } = this.state
        if (image.width && image.height) return
        Raven.captureMessage('Portfolio image with missing dimensions', {
            extra: {
                image,
            },
        })
        detectImageSize(url)
            .then(dims => {
                image.width = dims.width
                image.height = dims.height
                this.setState({
                    image,
                })
            })
    }

    render() {
        const { image, max } = this.state

        const target = getTargetSize(image, max)
        if (! target) return null

        // invert aspect and multiply by 100 to determing padding-bottom
        const paddingBottom = (1 / target.aspect) * 100

        const url = this.getUrl(image)

        const image_style = {
            maxWidth: `${target.width}px`,
        }
        // padding node has to sit inside the width-constraint node
        // (can't use width on the same node as the padding)
        const padding_style = {
            paddingBottom: `${paddingBottom}%`,
        }

        const title = image.title && image.title.trim() || 'Portfolio Image'

        return (
            <div className="image" style={image_style}>
                <div style={padding_style} />
                <img src={url} alt={title} />
            </div>
        )
    }
}
PortfolioImage.propTypes = {
    image: PropTypes.object.isRequired,
}
PortfolioImage.contextTypes = {
    globals: PropTypes.object.isRequired,
}

module.exports = PortfolioImage
